import type { MapNode } from "../types/nodes";
import { isFreshReading } from "./readingFreshness";

// Подпись под пином ноды на карте: «2° · 1 м/с» по свежему (≤ 90 мин)
// показанию станции. Нет свежего показания или температуры - подписи нет.
export const nodePinCaption = (node: MapNode, nowMs: number, windUnit: string): string | null => {
  const r = node.station?.latest;
  if (!r || !isFreshReading(r.polled_at, nowMs) || r.temp_c == null) return null;
  const temp = `${Math.round(r.temp_c)}°`;
  return r.wind_speed_ms == null ? temp : `${temp} · ${Math.round(r.wind_speed_ms)} ${windUnit}`;
};
